/* eslint-disable import/no-unresolved */
import React from 'react';
import api from '../../services/rewardsApi';
import Text from '../../components/Text';

function showSnackbar(snackbar, text, options) {
  snackbar.show(<Text> {text} </Text>, options);
}

export async function getTransactions(
  page = 1,
  { cnpj, finalFilter, setTransactions, setLoading, setPagination, snackbar }
) {
  if (page === 1) setLoading(true);
  try {
    const response = await api.get(
      `transactions/establishment/${cnpj}?page=${page}&${finalFilter}`
    );
    const { data, ...rest } = response.data;

    setPagination(rest.pagination);
    setTransactions(oldTransactions => {
      if (page === 1) {
        return data;
      }
      return [...oldTransactions, ...data];
    });
  } catch (error) {
    showSnackbar(snackbar, `Erro ao carregar transações`, {
      type: 'error',
    });
  } finally {
    setLoading(false);
  }
}
